import { BACKEND_URL } from '../../utils/apiConfig';

export const SPORTS = ['Pickleball', 'Badminton', 'Football', 'Throwball', 'Volleyball'];
export const TOURNAMENT_TYPES = ['Normal', 'DUPR', 'Team Event', 'PWR', 'Other'];
export const STATUSES = ['upcoming', 'ongoing', 'completed', 'cancelled'];

export const STATUS_STYLES = {
  upcoming: 'bg-amber-100 text-amber-700',
  ongoing: 'bg-emerald-100 text-emerald-700',
  completed: 'bg-slate-200 text-slate-700',
  cancelled: 'bg-red-100 text-red-700',
};

export const DATE_PRESETS = [
  { value: '', label: 'All Dates' },
  { value: 'last_month', label: 'Last Month' },
  { value: 'this_month', label: 'This Month' },
  { value: 'next_month', label: 'Next Month' },
  { value: 'next_3_months', label: 'Next 3 Months' },
  { value: 'custom', label: 'Custom Range' },
];

export const bannerUrl = (fileId) => (fileId ? `${BACKEND_URL}/api/files/${fileId}` : '');

export const emptyTournament = () => ({
  name: '', tournament_type: 'Normal', tournament_date: '', sport: 'Pickleball', venue: '',
  prize_pool: '', details: '', categories: '',
  organiser_name: '', organisation_name: '', contact_person: '', mobile_number: '', email: '', website: '', organised_managed_by: '',
  main_sponsor: '', registration_partner: '', official_venue_partner: '', other_sponsors: '',
  banner_file_id: '', banner_url: '', status: 'upcoming',
});

export const FIELD_LABELS = {
  name: 'Tournament Name', tournament_type: 'Tournament Type', tournament_date: 'Tournament Date',
  sport: 'Sport', venue: 'Venue', prize_pool: 'Prize Pool', details: 'Details', categories: 'Categories',
  organiser_name: 'Organiser Name', organisation_name: 'Organisation Name', contact_person: 'Contact Person',
  mobile_number: 'Mobile Number', email: 'Email', website: 'Website / Social Media', organised_managed_by: 'Organised & Managed By',
  main_sponsor: 'Main Sponsor', registration_partner: 'Registration Partner', official_venue_partner: 'Official Venue Partner',
  other_sponsors: 'Other Sponsors / Partners',
};

export const formatDate = (dateStr) => {
  if (!dateStr) return 'TBD';
  return new Date(dateStr).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' });
};
